"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNumberFormat = require("react-number-format");
var _material = require("@mui/material");
var _validators = require("../validators");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function AnyMakedInput(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? 'dense' : _ref$margin,
    format = _ref.format,
    _ref$mask = _ref.mask,
    mask = _ref$mask === void 0 ? '_' : _ref$mask,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    name = _ref.name,
    label = _ref.label,
    initialValue = _ref.initialValue,
    required = _ref.required,
    disabled = _ref.disabled,
    _ref$validators = _ref.validators,
    validators = _ref$validators === void 0 ? [] : _ref$validators,
    register = _ref.register,
    notifier = _ref.notifier;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    blured = _useState2[0],
    setBlured = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    valid = _useState4[0],
    setValid = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dirty = _useState6[0],
    setDirty = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var _useState9 = (0, _react.useState)(initialValue !== null && initialValue !== void 0 ? initialValue : ''),
    _useState10 = _slicedToArray(_useState9, 2),
    value = _useState10[0],
    setValue = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    formattedValue = _useState12[0],
    setFormattedValue = _useState12[1];
  var allValidators = (0, _react.useMemo)(function () {
    var allValidators = _toConsumableArray(validators);
    if (required) {
      allValidators = [_validators.TEXT_REQUIRED_VALIDATOR].concat(_toConsumableArray(validators));
    }
    return allValidators;
  }, [required, validators]);
  var ref = (0, _react.useRef)({
    valid: valid,
    dirty: dirty,
    value: value,
    setBlur: function setBlur() {
      return setBlured(true);
    }
  });
  var onMaskedInputChanged = function onMaskedInputChanged(values) {
    if (!values) return;
    setDirty(true);
    setValue(values['value']);
    setFormattedValue(values['formattedValue']);
  };
  var inputBlured = function inputBlured(_event) {
    if (!blured) {
      setBlured(true);
    }
  };
  var onNotify = (0, _react.useCallback)(function (value) {
    if (notifier) {
      notifier(name, value);
    }
  }, [notifier, name]);
  (0, _react.useEffect)(function () {
    var valid = true;
    var error;
    var _iterator = _createForOfIteratorHelper(allValidators),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var validator = _step.value;
        if (!validator.isValid(value)) {
          valid = false;
          error = validator.getMessage();
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    ref.current.valid = valid;
    ref.current.dirty = dirty;
    ref.current.value = value;
    setValid(valid);
    setError(error);
    onNotify(value);
  }, [value, dirty, allValidators, onNotify]);
  (0, _react.useEffect)(function () {
    register(name, ref.current);
  }, [register, name, ref]);
  (0, _react.useEffect)(function () {
    setValue(initialValue !== null && initialValue !== void 0 ? initialValue : '');
    setFormattedValue(initialValue !== null && initialValue !== void 0 ? initialValue : '');
  }, [initialValue]);
  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.PatternFormat, {
    customInput: _material.TextField,
    variant: variant,
    size: size,
    margin: margin,
    name: name,
    label: label,
    value: formattedValue,
    defaultValue: formattedValue,
    required: required,
    disabled: disabled,
    fullWidth: fullWidth,
    error: blured && !valid,
    helperText: blured ? error : undefined,
    onBlur: inputBlured,
    format: format,
    mask: mask,
    onValueChange: onMaskedInputChanged
  });
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AnyMakedInput);